export const calculateTotalAmount = (data: {amount, count}[]) => data?.reduce((prevValue, currentItem) => prevValue + currentItem.amount, 0)
export const calculateTotalCount = (data: {amount, count}[]) => data?.reduce((prevValue, currentItem) => prevValue + currentItem.count, 0)
